// extracted by mini-css-extract-plugin
module.exports = {"Container":"Page_Container__2RNEb","LeftCol":"Page_LeftCol__UL5Bn"};